import { render, staticRenderFns } from "./createcase.vue?vue&type=template&id=5490f91a"
import script from "./createcase.vue?vue&type=script&lang=js"
export * from "./createcase.vue?vue&type=script&lang=js"
import style0 from "./createcase.vue?vue&type=style&index=0&id=5490f91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports